import toast from "react-hot-toast";
import React, { useState } from "react";
import AuthService from "../services/auth.service";
import { Link, useNavigate } from "react-router-dom";
import FooterBar from "../components/FooterBar";
import { decryptData, encryptData } from "../helpers/Secure";
import { bearier_token } from "../services/auth.service";

const SignInForm = () => {
  const [nik, setNik] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const Auth = (e) => {
    e.preventDefault();
    const toastId = toast.loading("Mohon tunggu...");
    var nikEncoded = encryptData(bearier_token, nik);
    var passwordEncoded = encryptData(bearier_token, password);
    AuthService.login(nikEncoded, passwordEncoded).then(
      () => {
        toast.dismiss(toastId);
        navigate("/");
      },
      (error) => {
        toast.dismiss(toastId);
        const resMessage =
          (error.response && error.response.data && error.response.data.msg) ||
          error.message ||
          error.toString();

        toast.error(resMessage);
        if (error.response.status === 400) {
          navigate("/registrasi");
          localStorage.removeItem("aulia_pwa");
        }
      }
    );
  };

  return (
    <>
      <FooterBar />
      <div className="page-content">
        <div
          className="card bg-20"
          style={{ marginBottom: "-70px", height: "230px" }}
        >
          <div className="card-center text-center">
            <h1 className="color-white font-600 mb-n1 mt-n4 font-32 font-800">
              AULIA HOSPITAL
            </h1>
            <p className="color-white opacity-70">Your Healthcare Solution</p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
          <div
            className="card-bg preload-img"
            data-src="/assets/images/pictures/20s.jpg"
          />
        </div>

        <div className="card card-style">
          <div className="content mb-0">
            <div className="d-flex">
              <div className="me-auto">
                <h4 className="font-600">Selamat Datang</h4>
                <p className="font-11 mt-n2 mb-3">
                  Silahkan lengkapi form untuk masuk:
                </p>
              </div>
              <div className="ms-auto">
                <i
                  data-feather="user"
                  data-feather-line="1"
                  data-feather-size="40"
                  data-feather-color="blue-dark"
                  data-feather-bg="blue-fade-light"
                ></i>
              </div>
            </div>
            <div className="divider"></div>

            <form onSubmit={Auth}>
              <div className="input-style has-borders hnoas-icon input-style-always-active validate-field mb-4">
                <input
                  type="number"
                  className="form-control validate-name"
                  value={nik}
                  onChange={(e) => setNik(e.target.value)}
                />
                <label
                  htmlFor="form1"
                  className="color-highlight font-400 font-13"
                >
                  NIK
                </label>
                <i className="fa fa-times disabled invalid color-red-dark" />
                <i className="fa fa-check disabled valid color-green-dark" />
                <em>(required)</em>
              </div>
              <div className="input-style has-borders no-icon input-style-always-active validate-field mb-4">
                <input
                  type="password"
                  className="form-control validate-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <label
                  htmlFor="form4"
                  className="color-highlight font-400 font-13"
                >
                  Password
                </label>
                <i className="fa fa-times disabled invalid color-red-dark" />
                <i className="fa fa-check disabled valid color-green-dark" />
                <em>(required)</em>
              </div>

              <button
                type="submit"
                className="btn form-control btn-block btn-m mt-4 mb-4 btn-full bg-highlight rounded-sm text-uppercase font-900"
              >
                {/* {isLoading ? 'Mohon Tunggu...' : 'Masuk'} */}
                Masuk
              </button>
            </form>
            {/* <div className="me-auto">
              <p className="font-11 mt-n2 mb-3">
                Belum punya akun? <Link to="/registrasi">Daftar disini</Link>
              </p>
            </div> */}
            <div className="d-flex">
              <div className="w-50 font-11 pb-2 color-theme opacity-60 pb-3 text-start">
                <Link to="/registrasi" className="color-theme">
                  Daftar Akun
                </Link>
              </div>
              <div className="w-50 font-11 pb-2 color-theme opacity-60 pb-3 text-end">
                <Link className="color-theme" to="/forgot">
                  Lupa Password
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignInForm;
